var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCctv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -44 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45425a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3251"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 432.590493761,
    x2: 498.5291950352,
    xlinkHref: "#a",
    y1: 143.5671704236,
    y2: 143.5671704236
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 411.0832719706,
    x2: 411.0832719706,
    xlinkHref: "#a",
    y1: 236.9257924994,
    y2: 337.6088287028
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3251",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 373.7930912416,
    x2: 367.7665474756,
    xlinkHref: "#d",
    y1: 293.2066637414,
    y2: 273.000022902
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientTransform: "matrix(.939972 -.352577 .352577 .939972 -168.661933 -498.868123)",
    gradientUnits: "userSpaceOnUse",
    x1: 366.7307,
    x2: 366.7307,
    xlinkHref: "#a",
    y1: 710.0562,
    y2: 730.8113
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientTransform: "matrix(.939972 -.352577 .352577 .939972 -168.661933 -498.868123)",
    gradientUnits: "userSpaceOnUse",
    x1: -38.8952,
    x2: -38.8952,
    xlinkHref: "#a",
    y1: 793.5945,
    y2: 819.5282
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientTransform: "matrix(.939972 -.352577 .352577 .939972 -168.661933 -498.868123)",
    gradientUnits: "userSpaceOnUse",
    x1: -5.1009,
    x2: -5.1009,
    xlinkHref: "#a",
    y1: 816.1939,
    y2: 842.1063
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "matrix(.939972 -.352577 .352577 .939972 -168.661933 -498.868123)",
    gradientUnits: "userSpaceOnUse",
    x1: 224.7779,
    x2: 224.7779,
    xlinkHref: "#a",
    y1: 864.0934,
    y2: 890.3616
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 403.7015338968,
    x2: 332.8012493142,
    xlinkHref: "#d",
    y1: 275.082659091,
    y2: 224.7433998138
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(.939972 -.352577 .352577 .939972 -168.661933 -498.868123)",
    gradientUnits: "userSpaceOnUse",
    x1: 185.2379,
    x2: 185.2379,
    xlinkHref: "#k",
    y1: 792.2919,
    y2: 877.201
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 330.6245456338,
    x2: 286.4519776338,
    y1: 257.4150373818,
    y2: 177.1012773818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#c2e0ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#bfdcfd",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9eb2e7"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientTransform: "matrix(.939972 -.352577 .352577 .939972 -168.661933 -498.868123)",
    gradientUnits: "userSpaceOnUse",
    x1: 144.9736,
    x2: 144.9736,
    xlinkHref: "#k",
    y1: 706.0216,
    y2: 796.5958
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientTransform: "matrix(.939972 -.352577 .352577 .939972 -168.661933 -498.868123)",
    gradientUnits: "userSpaceOnUse",
    x1: 224.7779,
    x2: 224.7779,
    y1: 836.4745,
    y2: 877.1148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8be1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1873,
    stopColor: "#87e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3558,
    stopColor: "#7ce2dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5172,
    stopColor: "#6ae2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6741,
    stopColor: "#50e4ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8278,
    stopColor: "#2fe5c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9772,
    stopColor: "#07e7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e7b2"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 465.2060120892,
    x2: 465.2060120892,
    y1: 307.4461929972,
    y2: 403.7636743836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1596,
    stopColor: "#ff6440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    stopColor: "#ff4b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7662,
    stopColor: "#ff216e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0084"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 476.5501299048,
    x2: 505.6537282926,
    y1: 320.119603933,
    y2: 320.119603933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4286,
    stopColor: "#ffbb23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m492.855469 248.039062c-3.128907 0-5.671875-2.542968-5.671875-5.675781v-165.3125c0-8.292969-3.761719-15.960937-10.320313-21.035156-6.5625-5.070313-14.933593-6.789063-22.953125-4.703125l-14.21875 3.695312c-3.035156.785157-6.128906-1.035156-6.917968-4.0625-.785157-3.035156 1.03125-6.128906 4.066406-6.917968l14.21875-3.691406c11.449218-2.976563 23.382812-.53125 32.746094 6.707031 9.355468 7.238281 14.726562 18.175781 14.726562 30.007812v165.3125c0 3.132813-2.542969 5.675781-5.675781 5.675781zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m461.425781 337.609375h-63.25c-15.351562 0-29.246093-9.679687-34.570312-24.078125l-19.484375-52.730469c-3.394532-9.183593 1.300781-19.378906 10.480468-22.773437 9.183594-3.390625 19.378907 1.300781 22.773438 10.484375l19.484375 52.726562c.203125.550781.734375.917969 1.316406.917969h63.25c9.789063 0 17.722657 7.9375 17.722657 17.726562 0 9.789063-7.933594 17.726563-17.722657 17.726563zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m377.375 248.511719c-3.394531-9.183594-13.589844-13.875-22.773438-10.480469-9.183593 3.390625-13.875 13.585938-10.480468 22.769531l16.339844 44.21875 33.164062-12.527343zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m436.769531 74.96875-15.933593 5.976562-15.933594-42.484374 15.929687-5.976563c11.734375-4.402344 24.8125 1.542969 29.210938 13.273437 4.402343 11.734376-1.539063 24.8125-13.273438 29.210938zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m104.777344 298.949219-17.605469 6.605469c-5.660156 2.121093-11.972656-.746094-14.09375-6.40625l-12.222656-32.585938c-2.125-5.660156.742187-11.972656 6.402343-14.097656l17.609376-6.601563zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m153.070312 301.785156-29.789062 11.171875c-9.578125 3.59375-20.253906-1.257812-23.847656-10.835937l-20.683594-55.136719c-3.589844-9.574219 1.261719-20.25 10.839844-23.84375l29.789062-11.175781zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m396.621094 265.707031-65.71875 24.652344c-9.347656 3.507813-19.769532-1.230469-23.277344-10.578125l-13.820312-36.84375 99.574218-37.347656 13.820313 36.839844c3.507812 9.347656-1.226563 19.769531-10.578125 23.277343zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m396.621094 265.707031c9.351562-3.503906 14.085937-13.925781 10.578125-23.277343l-13.820313-36.84375-99.574218 37.351562 8.324218 22.195312 43.417969 19.734376zm0 0",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m163.042969 317.089844 295.300781-110.765625c14.140625-5.304688 21.308594-21.070313 16.003906-35.214844l-35.214844-93.878906-338.539062 126.988281 38.203125 101.851562c3.652344 9.738282 14.507813 14.671876 24.246094 11.019532zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m115.25 243.292969 110.566406 50.25 232.527344-87.222657c14.140625-5.304687 21.308594-21.070312 16.003906-35.210937l-35.214844-93.878906-338.539062 126.988281zm0 0",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m455.527344 120.941406-308.019532 115.535156c-58.660156 22.003907-124.054687-7.710937-146.054687-66.375-4.402344-11.730468 1.539063-24.808593 13.273437-29.207031l371.75-139.445312c11.730469-4.398438 24.808594 1.546875 29.210938 13.277343zm0 0",
    fill: "url(#n)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m259.574219 280.878906 184.546875-69.222656-8.007813-21.339844c-7.425781-19.800781-29.492187-29.828125-49.292969-22.402344l-112.851562 42.328126c-19.800781 7.425781-29.828125 29.496093-22.402344 49.296874zm0 0",
    fill: "url(#o)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m469.8125 376.574219c-9.332031 0-16.894531-7.566407-16.894531-16.898438v-79.113281c0-9.332031 7.5625-16.898438 16.894531-16.898438 4.242188 0 7.683594 3.4375 7.683594 7.679688v97.546875c0 4.246094-3.4375 7.683594-7.683594 7.683594zm0 0",
    fill: "url(#p)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m497.820312 424.34375c-17.230468 0-31.195312-13.96875-31.195312-31.195312v-146.054688c0-17.230469 13.964844-31.195312 31.195312-31.195312 7.832032 0 14.179688 6.347656 14.179688 14.179687v180.085937c0 7.832032-6.347656 14.179688-14.179688 14.179688zm0 0",
    fill: "url(#q)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCctv);
export default __webpack_public_path__ + "static/media/icon-cctv.2eb3320aa0b849eb46a9a25a041e0283.svg";
export { ForwardRef as ReactComponent };